import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
// import * as firebase from "firebase";
import { eventChannel } from 'redux-saga'
import { call, put, takeEvery, take, select, delay } from 'redux-saga/effects';
import * as LinesApi from '../Api/LinesApi';
import * as TimeLineApi from '../Api/TimeLineApi';
import * as TimeLineResponsesApi from '../Api/TimeLineResponsesApi';

import * as LineSendsApi from '../Api/LineSendsApi';
import * as LineUserResponsesApi from '../Api/LineUserResponsesApi';
import { reset } from 'redux-form';

// import console = require('console');
// import * as Common from './Common';

export interface LineState {
    lines: any;
    response_lines: any;
    line_user_details: any;
    line_user_details_response: any;
    line_bottom: boolean;
    line_send: boolean;
    get_line_open: any;
    line_open_flg: boolean;
    response_line_bottom: boolean;
}

const initialState: LineState = {

    // mails: [],
    lines: [],
    response_lines: [],
    line_user_details: [],
    line_user_details_response: [],
    line_bottom: false,
    response_line_bottom: false,
    line_send: false,
    get_line_open: [],
    line_open_flg: false
}



///action
const actionCreator = actionCreatorFactory();



export const get_lines = actionCreator('GET_LINES');
export const get_response_lines = actionCreator('GET_RESPONESE_LINES');
export const get_lines_success = actionCreator<any>("GET_LINES_SUCCESS");

export const get_response_lines_success = actionCreator<any>("GET_RESPONSE_LINES_SUCCESS");


export const send_message = actionCreator<any>('SEND_MESSAGE');

export const get_line_user_details = actionCreator<any>('GET_LINE_USER_DETAILS');
export const get_line_user_details_success = actionCreator<any>("GET_LINE_USER_DETAILS_SUCCESS");

export const get_line_user_details_response = actionCreator<any>('GET_LINE_USER_DETAILS_RESPONSE');
export const get_line_user_details_response_success = actionCreator<any>("GET_LINE_USER_DETAILS_RESPONSE_SUCCESS");


export const change_line_bottom = actionCreator<any>('CHANGE_LINE_BOTTOM');
export const change_response_line_bottom = actionCreator<any>('CHANGE_RESPONSE_LINE_BOTTOM');

export const change_line_send = actionCreator<any>('CHANGE_LINE_SEND');


export const get_line_open = actionCreator<any>('GET_LINE_OPEN');
export const get_line_close = actionCreator<any>('GET_LINE_CLOSE');


export const change_line_open_flg = actionCreator<any>('CHANGE_LINE_OPEN_FLG');

export const lineReducer = reducerWithInitialState(initialState)


    .case(get_lines_success, (state, payload) => ({ ...state, lines: payload }))
    .case(get_response_lines_success, (state, payload) => ({ ...state, response_lines: payload }))

    .case(get_line_user_details_success, (state, payload) => ({ ...state, line_user_details: payload }))
    .case(change_line_bottom, (state, payload) => ({ ...state, line_bottom: payload }))
    .case(change_response_line_bottom, (state, payload) => ({ ...state, response_line_bottom: payload }))
    .case(change_line_send, (state, payload) => ({ ...state, line_send: payload }))
    .case(change_line_open_flg, (state, payload) => ({ ...state, line_open_flg: payload }))

    .case(get_line_user_details_response_success, (state, payload) => ({ ...state, line_user_details_response: payload }))


// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const lineSaga = [takeEvery('GET_LINES', handle_get_lines),
takeEvery('GET_RESPONESE_LINES', handle_get_response_lines),
takeEvery('SEND_MESSAGE', handle_send_message),
takeEvery('GET_LINE_USER_DETAILS', handle_get_line_user_details),
takeEvery('GET_LINE_OPEN', handle_get_line_open),
takeEvery('GET_LINE_CLOSE', handle_get_line_close),
takeEvery('GET_LINE_USER_DETAILS_RESPONSE', handle_get_line_user_details_response),


];



function* handle_get_lines(action: any) {

    const { payload, error } = yield call(TimeLineApi.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // 成功時アクション呼び出し
        yield put(get_lines_success(payload))
        // yield put(change_get_mail_details_loading(0));


    } else {


    }
}





function* handle_get_line_open(action: any) {
    //    alert(action.payload)
    yield put(get_line_user_details(action.payload))

    const { payload, error } = yield call(TimeLineResponsesApi.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)
        // alert()
        // 成功時アクション呼び出し
        yield put(get_lines_success(payload))
        yield put(change_line_bottom(true));
        // yield put(change_get_mail_details_loading(0));
        yield put(change_line_open_flg(true))

    } else {


    }
}



function* handle_get_line_close(action: any) {
    //    alert(action.payload)
    yield put(get_line_user_details_success({}))
    yield put(get_lines_success({}))
    // yield put(change_get_mail_details_loading(0));
    yield put(change_line_open_flg(false))
}

function* handle_get_response_lines(action: any) {
    console.log(action.payload)

    if (action.payload.lineuserid) {

        const { payload, error } = yield call(TimeLineApi.list, action.payload);
        if (payload && !error) {
            console.log(payload)
            yield put(change_response_line_bottom(true));
            // 成功時アクション呼び出し
            yield put(get_response_lines_success(payload))
            // yield put(change_get_mail_details_loading(0));


        } else {


        }
    } else {

        yield put(get_line_user_details_response(action.payload))

        const { payload, error } = yield call(TimeLineResponsesApi.list, action.payload);
        if (payload && !error) {
            console.log(payload)
            yield put(change_response_line_bottom(true));
            // 成功時アクション呼び出し
            yield put(get_response_lines_success(payload))
            // yield put(change_get_mail_details_loading(0));


        } else {


        }
    }
    // const { payload, error }= yield call(TimeLineApi.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理

}

function* handle_get_line_user_details(action: any) {

    const { payload, error } = yield call(LineUserResponsesApi.getdetail, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // 成功時アクション呼び出し
        yield put(get_line_user_details_success(payload))
        // yield put(change_get_mail_details_loading(0));


    } else {


    }
}
function* handle_get_line_user_details_response(action: any) {

    const { payload, error } = yield call(LineUserResponsesApi.getdetail, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // 成功時アクション呼び出し
        yield put(get_line_user_details_response_success(payload))
        // yield put(change_get_mail_details_loading(0));


    } else {


    }
}

function* handle_send_message(action: any) {

    if (action.payload.MessageText) {
        yield put(change_line_send(true));
    }
    const { payload, error } = yield call(LineSendsApi.send, action.payload);


    // yield put(change_line_bottom(true));
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {


        // yield put(reset('linesendform'));
        yield put(change_line_send(false));
        //    const { payload2, error2 }= yield call(TimeLineApi.list, action.payload.responseId);


        // サーバーからのレスポンスデータによる分岐処理
        //    if (payload2 && !error2) {
        //     yield put(change_line_bottom(true));
        //    // 成功時アクション呼び出し
        //    yield put(get_lines_success(payload2))
        //        // yield put(change_get_mail_details_loading(0));



        //    } else {


        //    }

    } else {


    }
}

